import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { getHpaV2MigrationEligibilityQueryKey } from 'hooks/queries/workload-optimization/useHpaV2MigrationEligibilityQuery';
import { getWorkloadQueryKey } from 'hooks/queries/workload-optimization/useWorkloadQuery';
import { getWorkloadsQueryKey } from 'hooks/queries/workload-optimization/useWorkloadsQuery';

type UseMigrateClusterToHpaV2MutationArgs = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useMigrateClusterToHpaV2Mutation = ({
  onSuccess,
  onError,
}: UseMigrateClusterToHpaV2MutationArgs = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiClient.workloadOptimization.migrateClusterToHpaV2,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getHpaV2MigrationEligibilityQueryKey(),
      });
      queryClient.invalidateQueries({
        queryKey: getWorkloadsQueryKey(),
      });
      queryClient.invalidateQueries({ queryKey: getWorkloadQueryKey() });
      onSuccess?.();
    },
    onError,
  });
};
